/* esm.sh - rxjs@7.8.2/dist/esm/internal/operators/mergeAll */
import{mergeMap as t}from"rxjs/dist/esm/internal/operators/mergeMap";import{identity as e}from"rxjs/dist/esm/internal/util/identity";function n(r=1/0){return t(e,r)}export{n as mergeAll};
//# sourceMappingURL=mergeAll.mjs.map